const products_on_page = document.getElementById('product-grid');
const nextUrl = document.getElementById('paginateNext');

// let next_url = nextUrl ? nextUrl.dataset.nextUrl : null;

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

async function getNextPage() {
  const next_url = document.getElementById('paginateNext')?.dataset.nextUrl;

  if (!next_url || next_url.trim() === "") {
    console.error("No next URL found. Stopping fetch.");
    return null;
  }

  console.log("Fetching next_url =>", next_url);

  try {
    const res = await fetch(next_url);
    if (!res.ok) {
      console.error("Failed to fetch next page: HTTP", res.status);
      return null;
    }

    return await res.text();
  } catch (error) {
    console.error("Error fetching next page:", error);
    return null;
  }
}

async function loadMoreProducts() {
  const next_url = document.getElementById('paginateNext')?.dataset.nextUrl;

  if (!next_url || next_url.trim() === "") {
    console.log("No next page available.");
    document.querySelector('.load-more').style.display = 'none';
    return;
  }

  document.querySelector('.load-more_btn').style.display = 'none';
  document.querySelector('.load-more_spinner').style.display = 'block';

  const nextPage = await getNextPage();

  if (!nextPage) {
    document.querySelector('.load-more_spinner').style.display = 'none';
    console.error("Failed to fetch next page content.");
    return;
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = nextPage;

  const productgrid = tempDiv.querySelector('#product-grid');
  if (!productgrid) {
    console.error("No product grid found in the fetched page.");
    document.querySelector('.load-more_spinner').style.display = 'none';
    return;
  }

  const new_products = Array.from(productgrid.getElementsByClassName('grid__item'));
  console.log("New products count =>", new_products.length);

  const oldPaginateNext = document.getElementById('paginateNext');
  if (oldPaginateNext) oldPaginateNext.remove();

  const newPaginateNext = tempDiv.querySelector('#paginateNext');
  const new_url = newPaginateNext ? newPaginateNext.dataset.nextUrl : null;

  console.log("newPaginateNext =>", newPaginateNext);
  console.log("Extracted new next_url =>", new_url);

  if (newPaginateNext) {
    document.body.appendChild(newPaginateNext); // append where needed
  }

  new_products.forEach(product => {
    document.getElementById('product-grid').appendChild(product);
  });

  const viewedCountEl = document.getElementById('viewed-count');
  if (viewedCountEl) {
    let currentViewedCount = parseInt(viewedCountEl.textContent, 10) || 0;
    currentViewedCount += new_products.length;
    viewedCountEl.textContent = currentViewedCount;
  }

  if (new_url && new_url.trim() !== "") {
    document.querySelector('.load-more_btn').style.display = 'flex';
  } else {
    console.log("No further pages available. Hiding full load-more wrapper.");
    document.querySelector('.load-more').style.display = 'none';
  }

  document.querySelector('.load-more_spinner').style.display = 'none';
}


